import React, { useCallback, useMemo } from "react";
import { isArray, compact } from "lodash";

import { Input, IDropdownOption, SelectColor, ChipTag, glyphs } from "@treelab/panda";
import { StatusType } from "@treelab/common-logic";

import { IFilterValue } from "../../../../../../types/form-type";
import { ITableColumn, ColumnType } from "../../../../../../types/table-type";
import { getIsMulti } from "../../../../../../utils/form_secondary";

interface IProps {
  name: string;
  isDisabled?: boolean;
  value: IFilterValue;
  column: ITableColumn<ColumnType.STATUS>;
  onChange: (value: { [key: string]: any }) => void;
}

export const StatusSelector: React.FC<IProps> = ({ value, column, name, onChange }) => {
  const {
    type,
    typeOptions: { statuses },
  } = column;
  const { filterString, filterCondition } = value;
  const isMulti = useMemo(() => {
    return getIsMulti(type, filterCondition);
  }, [filterCondition, type]);
  const handleSelectChange = useCallback(
    (data: string[] | string) => {
      onChange({ filterString: isArray(data) ? compact(data) : data });
    },
    [onChange]
  );

  return (
    <Input.Select
      isRequired={false}
      meta={{}}
      input={{
        name: `${name}.multiSelect`,
        onChange: handleSelectChange,
        value: Array.isArray(filterString) ? filterString : [filterString],
      }}
      includeSearch={isMulti}
      isMulti={isMulti}
      options={statuses.map<IDropdownOption>(({ statusId, type, name, color }) => {
        return {
          name,
          params: {
            color,
          },
          value: statusId,
          icon: type === StatusType.DONE ? glyphs.COMPLETE_WHITE : undefined,
        };
      })}
      renderValues={(values: string[]): React.ReactNode => {
        return (
          <>
            {values.map((value) => {
              const option = statuses.find(({ statusId }) => value === statusId);
              if (!option) return null;
              return (
                <ChipTag
                  icon={option.type === StatusType.DONE ? glyphs.COMPLETE_WHITE : undefined}
                  key={option.statusId}
                  color={option.color as SelectColor}
                  text={option.name}
                />
              );
            })}
          </>
        );
      }}
      renderItem={(option: IDropdownOption): React.ReactNode => {
        return <ChipTag icon={option.icon} color={option.params.color} text={option.name} />;
      }}
    />
  );
};
